import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket/store'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type IResponseEventToggleRingEverywhere } from 'entities/Users/api/types'

type IHandlerEvent = (data: IResponseEventToggleRingEverywhere) => void

export const useEventToggleRingEverywhere = (handler?: IHandlerEvent) => {
  const { websocket, usersStore } = useEntitiesContext()

  const defaultHandler = (data: IResponseEventToggleRingEverywhere) => {
    usersStore.isRingEverywhere = data.isRingEverywhere
    handler?.(data)
  }

  useEffect(() => websocket.on(WebsocketEvent.UserToggleRingEverywhere, defaultHandler), [])
}
